import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';

export const Section = styled.div`
  margin-bottom: 4px;
  padding-top: 8px;
  border-top: 1px solid ${grey.z200};

  &:first-child {
    margin-top: 16px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  cursor: pointer;
  color: ${grey.z500};

  &:hover {
    opacity: 0.8;
  }
`;
